<div style="max-height: calc(100vh - 180px); overflow: auto;">
  <owc-card class="msg-attach " style="box-shadow: none;">
    <div class="msg-attach-content">
    <div class="msg-attach-title">Message and attachments</div>
    <div class="msg-attach-sub-title">Message </div>
    <div class="msg-attach-subject">

    <owc-input style="width: 100%; flex: 1;" variant="outlined" label="Subject"
      [formControl]="subjectname"
      (keyup)="onKeyupSubjectName($event)"
      (blur)="onBlurSubjectName($event)"
      min="5"
      max="250"
      [value]="subValue"
      >
    </owc-input>

      <owc-button one-secondary-button style="margin-left: 24px;"
        (click)="openMsgAttachTempleteDialog(); visible = true">
        Templates
      </owc-button>

      <owc-modal-dialog [(ngModel)]="visible">
        <dl-message-attachment-template-dialog [inputData]="inputData" (closeDialog)="onDialogClose($event)"></dl-message-attachment-template-dialog>
      </owc-modal-dialog>


    </div>
    <dl-rich-text-document [jsonTextItem]="textDoc" [showInEditor]=""
      (jsonTextReturn)="setRTEText($event)"></dl-rich-text-document>


      
    <!-- TODO: After checking the checkbox, the Apply button is not getting enabled -->
    <div class="msg-attach-templete-apply">
      <owc-checkbox #checkboxElement [(ngModel)]="addTempleteCheck" (change)="chkApplyChange($event)"
        [disabled]="disabledApplyCheckbox" style="flex:1">Add this message to your templates</owc-checkbox>
      <owc-button [disabled]="disbledApplyButton" (click)="onApplybuttonAction()">
        Apply
      </owc-button>
    </div>
    <div class="msg-attach-sub-title top-margin-24">Attachments </div>
    <dl-file-upload-multiple [fileUploadwithCheck]="'multiple'"></dl-file-upload-multiple>
    </div>
  </owc-card>
</div>